import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { DataFieldGroup } from '../../shared/datafields/models/datafield-group';
import { DataFieldValue } from '../../shared/datafields/models/datafield-value';
import { JsonHttpService } from '../../shared/http/json-http.service';

@Injectable({
    providedIn: 'root'
})
export class TrackingFieldService {

    constructor(private httpService: JsonHttpService) { }

    public getGroupedDataFieldsForDistributionObject(distributionObjectId: number): Promise<DataFieldGroup[]> {
        const options = { params: new HttpParams().set('distributionObjectId', `${distributionObjectId}`) };
        return this.httpService.get('/api/tracking/trackingfields/get-grouped-datafields-for-distribution-object', options).toPromise();
    }

    public getGroupedDataFieldsForDocument(documentId: number): Promise<DataFieldGroup[]> {
        const options = { params: new HttpParams().set('documentId', `${documentId}`) };
        return this.httpService.get('/api/tracking/trackingfields/get-grouped-datafields-for-document', options).toPromise();
    }

    /**
     * Generates a string which can be used when doing a tracking-search with tracking-fields.
     * Returns a string like: '123--Something##321--SomethingElse'
     * @param datafieldValues The datafields to generate the search-parameter-string from.
     */
    public generateTrackingFieldSearchParameters(datafieldValues: DataFieldValue[]): string {
        const trackingFieldsDelimiter = '_!!_';
        const valueDelimiter = '-!!-';

        const params = datafieldValues.map((d) => {
            return (d.CallbackReferenceId + valueDelimiter + d.Value);
        });
        return params.join(trackingFieldsDelimiter);
    }
}
